import { defineMessages } from 'react-intl';

export default defineMessages({
    theirDetails: {
        id: 'spm.views.additionalDrivers.theirDetails',
        defaultMessage: 'About the additional driver(s)'
    },
    theirDrivingHistory: {
        id: 'spm.views.additionalDrivers.theirDrivingHistory',
        defaultMessage: 'Driving history'
    },
    theirClaimsAndConvictions: {
        id: 'spm.views.additionalDrivers.claimsAndConvictions',
        defaultMessage: 'Claims and convictions'
    }
});
